import React from "react";
import { HiMiniWallet } from "react-icons/hi2";
import { IoMagnetOutline, IoSettings } from "react-icons/io5";
import { BsFileEarmarkSpreadsheet, BsPersonFillAdd } from "react-icons/bs";
import { FaSheetPlastic } from "react-icons/fa6";
import { RiMailAddLine } from "react-icons/ri";
import { SiConvertio } from "react-icons/si";
import { FaRegFilePowerpoint, FaFileContract } from "react-icons/fa";

// Libellés du champ Pôle — détermine le profil du Bureau affiché à
// l'utilisateur (voir Bureau.jsx#profileForUser).
export const POLE_LABELS = {
  COMPTABILITE: "Comptabilité",
  SOCIAL: "Social",
  SECRETARIAT: "Secrétariat",
  JURIDIQUE: "Juridique",
};

// Pôle par défaut tant qu'aucun n'a été choisi explicitement — reproduit
// exactement la même règle que Bureau.jsx#profileForUser (rôle -> à défaut
// le texte du poste), pour que la valeur affichée/pré-remplie ici dans
// l'Admin corresponde toujours à ce que l'utilisateur voit réellement dans
// son Bureau : Secrétariat -> Secrétariat/Direction, Social -> Gestion de
// paie, Juridique -> Juridique, tout le reste -> Comptable.
const ROLE_TO_POLE = {
  SECRETARIAT: "SECRETARIAT",
  SOCIAL: "SOCIAL",
  JURIDIQUE: "JURIDIQUE",
};
function normalizePoleText(str) {
  return (str || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}
export function defaultPoleForUser(user) {
  const byRole = ROLE_TO_POLE[user?.role];
  if (byRole) return byRole;
  const poste = normalizePoleText(user?.poste);
  if (poste.includes("juridique") || poste.includes("juriste")) return "JURIDIQUE";
  if (poste.includes("social") || poste.includes("paie")) return "SOCIAL";
  if (poste.includes("secretariat")) return "SECRETARIAT";
  return "COMPTABILITE";
}

export const MODULE_KEYS = [
  "Admin",
  "Portefeuille",
  "Lead",
  "Suivi Prod",
  "Créer une lettre de mission",
  "Créer un contrat de travail",
  "Ajouter un client",
  "Créer un évènement",
  "Créer une note de RDV",
  "Créer une mission ponctuelle",
];

// Fonction qui retourne une icône en fonction de la fonctionnalité
export const getFunctionalityIcon = (fonctionalite, active = true) => {
  const color = active ? "#ffffff" : "#c9c2bd";
  const icons = {
    Admin: <IoSettings size={14} color={color} />,
    Portefeuille: <HiMiniWallet size={14} color={color} />,
    Lead: <IoMagnetOutline size={14} color={color} />,
    "Suivi Prod": <BsFileEarmarkSpreadsheet size={14} color={color} />,
    "Créer une lettre de mission": <FaSheetPlastic size={14} color={color} />,
    "Créer un contrat de travail": <FaFileContract size={14} color={color} />,
    "Ajouter un client": <BsPersonFillAdd size={14} color={color} />,
    "Créer un évènement": <SiConvertio size={14} color={color} />,
    "Créer une note de RDV": <RiMailAddLine size={14} color={color} />,
    "Créer une mission ponctuelle": (
      <FaRegFilePowerpoint size={14} color={color} />
    ),
  };

  return icons[fonctionalite] || null; // Renvoie l'icône correspondante ou rien si non trouvé
};
